import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import store from './store/index.js'
import config from './config/config.js'
import "@/css/index.less"
import "@/css/pop.less"
import "@/css/reset.css"
Vue.config.productionTip = false

Vue.use(VueI18n)

var userLanguage = navigator.language || navigator.userLanguage;
let defaultLanguage = "en"
console.log(userLanguage);
if(userLanguage.indexOf("zh") != -1){
  defaultLanguage = "tc"
}else if(userLanguage.indexOf("en") != -1){
  defaultLanguage = "en"
}else if(userLanguage.indexOf("ja") != -1){
  defaultLanguage = "ja"
}else if(userLanguage.indexOf("ko") != -1){
  defaultLanguage = "ko"
}

let lan = localStorage.getItem("r3-twitch-lan") || defaultLanguage

console.log(lan);

const i18n = new VueI18n({
  locale:  lan, // 设置地区
  messages:config, // 设置地区信息
})

new Vue({
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
